import { EmailParseStatus, IEmailUtilityAutomation, IEmailUtilityAutomationHistory } from '../../domain/email-utility-automation/interface';
import { ERROR_COLOR, INFO_COLOR, SECONDARY_COLOR, SUCCESS_COLOR, WARNING_COLOR } from '../../theme';

export function getEmailUtilityAutomationHistoryText(historyItem: IEmailUtilityAutomationHistory) {
    switch (historyItem.status) {
        case EmailParseStatus.SUCCESS:
            return `Successfully created event to ${historyItem.created_events_count} sites`;
        case EmailParseStatus.PARSER_DISABLED:
            return `Received email but parser was disabled`;
        case EmailParseStatus.IGNORED:
            return `Email parsing was skipped`;
        case EmailParseStatus.FAILED:
            return `Parsing Error: ${historyItem.error_message}`;
        case EmailParseStatus.IN_PROGRESS:
            return `Received email. Parsing in progress`;
        default:
            return 'Unknown status';
    }
}

export function getEmailUtilityAutomationHistoryStatusColor(status: EmailParseStatus) {
    switch (status) {
        case EmailParseStatus.SUCCESS:
            return SUCCESS_COLOR;
        case EmailParseStatus.PARSER_DISABLED:
            return SECONDARY_COLOR;
        case EmailParseStatus.IGNORED:
            return WARNING_COLOR;
        case EmailParseStatus.FAILED:
            return ERROR_COLOR;
        case EmailParseStatus.IN_PROGRESS:
            return INFO_COLOR;
        default:
            return INFO_COLOR;
    }
}

export function filterEmailUtilityAutomationsBySearch(
    emailUtilityAutomations: IEmailUtilityAutomation[],
    search?: string | number
): IEmailUtilityAutomation[] {
    if (!search) {
        return emailUtilityAutomations;
    }

    return emailUtilityAutomations.filter(emailUtilityAutomation => {
        return (
            emailUtilityAutomation.title.toLowerCase().includes(search.toString().toLowerCase()) ||
            emailUtilityAutomation.receiving_from.some((email: string) => email.toLowerCase().includes(search.toString().toLowerCase()))
        );
    });
}
